/**
 * MP FAQ accordion — one open panel at a time within each [data-mp-faq] root.
 */
(function () {
  function initFaq(root) {
    var items = root.querySelectorAll('.mp-faq__item');
    items.forEach(function (item) {
      var trigger = item.querySelector('[data-mp-faq-trigger]');
      var panel = item.querySelector('[data-mp-faq-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (other) {
          other.classList.remove('is-open');
          var t = other.querySelector('[data-mp-faq-trigger]');
          var p = other.querySelector('[data-mp-faq-panel]');
          if (t) t.setAttribute('aria-expanded', 'false');
          if (p) p.hidden = true;
        });
        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-mp-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-mp-faq]');
    if (root) initFaq(root);
  });
})();
